import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled from 'styled-components';
import { rem } from 'polished';
import { media } from '~layout';
var AssetContainer = styled.div.withConfig({
  displayName: "AssetContainer",
  componentId: "sc-12qkfi5-0"
})(["align-items:center;display:flex;height:100%;justify-content:flex-start;padding:", " 0;", ""], rem(32), media.sm(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        align-items: center;\n        justify-content: center;\n        padding: ", " 0;\n    "])), rem(16)));
export default AssetContainer;